"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PIAThemeContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _defaultBrandContext = require("../../defaults/defaultBrandContext");
var _contactStatement = require("../../defaults/contactStatement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable max-len */
var PIAThemeContext = exports.PIAThemeContext = _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext), {}, {
  brand: {
    key: 'pia',
    title: 'PIA',
    fullName: 'Pet Insurance Australia',
    shortName: 'Pet Insurance Australia',
    homeUrl: 'https://www.petinsuranceaustralia.com.au/',
    cssUrls: null,
    logos: [{
      key: 'petInsuranceLogo',
      imageUrl: 'https://petcdnstore.blob.core.windows.net/qt-assets/Prod/PIA/PIA_logo.png',
      redirectUrl: 'https://www.petinsuranceaustralia.com.au/'
    }],
    supportPhoneNumber: '1800 043 552',
    supportEmailAddress: 'pia@petsure.com.au',
    products: 'pia',
    partner: 'PIA',
    broker: 'PIA',
    marketingPartner: 'Pet Insurance Australia',
    favIconUrl: 'https://www.petinsuranceaustralia.com.au/wp-content/uploads/2023/12/Pet_Insurance_Australia_Favicon-min-removebg-preview-70x70.webp',
    appIcon: 'https://www.petinsuranceaustralia.com.au/wp-content/uploads/2023/12/Pet_Insurance_Australia_Favicon-min-removebg-preview-300x300.webp',
    certificateIssuer: 'sectigo',
    certificateIssuerUrl: 'https://sectigo.com',
    partnerPrefix: 'PI',
    styleSheet: 'pia',
    gtmId: 'P6HNPK',
    gtmDataLayer: 'dataLayer',
    actionButtonsBars: _objectSpread({}, _defaultBrandContext.DefaultBrandContext.brand.actionButtonsBars)
  },
  seo: {
    title: 'PIA Pet Insurance',
    description: 'Up to 90% back* on eligible vet bills. Get a quote in under 2 minutes.'
  },
  tracking: [{
    provider: 'GoogleAnalytics',
    key: 'gtmKey',
    keyValue: 'GTM-P6HNPK'
  }],
  layout: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout), {}, {
    header: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout.header), {}, {
      contactDetails: /*#__PURE__*/_react["default"].createElement("aside", {
        className: "contactDetails"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "button primary",
        href: "tel://1800043552"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "labelText"
      }, "Call us: 1800 043 552")), /*#__PURE__*/_react["default"].createElement("span", null, "Mon-Fri 8am-8pm AEST"))
    }),
    footer: _objectSpread(_objectSpread({}, _defaultBrandContext.DefaultBrandContext.layout.footer), {}, {
      socialLinks: [{
        icon: 'facebook',
        label: 'Facebook',
        url: 'https://www.facebook.com/Pet-Insurance-Australia-174437189275534/',
        svg: /*#__PURE__*/_react["default"].createElement(_components.FacebookSvg, null)
      }, {
        icon: 'twitter',
        label: 'Twitter',
        url: 'https://twitter.com/PetInsuranceAus',
        svg: /*#__PURE__*/_react["default"].createElement(_components.TwitterSvg, null)
      }, {
        icon: 'pinterest',
        label: 'Pinterest',
        url: 'https://www.pinterest.com/petinsuranceaus/',
        svg: /*#__PURE__*/_react["default"].createElement(_components.PinterestSvg, null)
      }, {
        icon: 'instagram',
        label: 'Instagram',
        url: 'https://www.instagram.com/petinsuranceaustralia/',
        svg: /*#__PURE__*/_react["default"].createElement(_components.InstagramSvg, null)
      }],
      copyright: null,
      customDisclosure: {
        brand: {
          label: 'Pet Insurance Australia'
        },
        pds: {
          link: 'https://www.petinsuranceaustralia.com.au/useful-documents/',
          label: 'Product Disclosure Statement (PDS)'
        },
        tmd: {
          link: 'https://www.petinsuranceaustralia.com.au/',
          label: 'petinsuranceaustralia.com.au'
        },
        vetChatTAndC: {
          link: 'http://petinsuranceaustralia.vetchat.com.au/terms-and-conditions',
          label: 'petinsuranceaustralia.vetchat.com.au/terms-and-conditions'
        },
        vetChatSignUp: {
          link: 'https://petinsuranceaustralia.vetchat.com.au/signup',
          label: 'petinsuranceaustralia.vetchat.com.au/signup'
        },
        authorisedRepresentative: 'PetSure’s Authorised Representative (AR) Pet Insurance Australia Pty Ltd ABN 85 113 507 850, AR 326233',
        footerDisclaimer: function footerDisclaimer(props) {
          return /*#__PURE__*/_react["default"].createElement("p", null, "This policy is issued by PetSure (Australia) Pty Ltd ABN 95 075 949 923, AFSL 420183 (PetSure) and promoted and distributed by PetSure\u2019s Authorised Representative (AR) Pet Insurance Australia Pty Ltd ABN 85 113 507 850, AR 326233. Any advice provided is general only and does not take into account your individual objectives, financial situation or needs. Please consider the ", /*#__PURE__*/_react["default"].createElement("a", {
            target: "_blank",
            rel: "noreferrer",
            href: props.pds.link
          }, props.pds.label), "\xA0 to ensure this product meets your needs before purchasing. PDS and Target Market Determination available at ", /*#__PURE__*/_react["default"].createElement("a", {
            target: "_blank",
            rel: "noreferrer",
            href: props.tmd.link,
            ref: props.disclaimerLink
          }, props.tmd.label), ".");
        },
        hasExtraVetChatDescription: true,
        myPetPass: {
          hasMyPetPass: true,
          eligibilityWordings: 'Available only to holders of active Pet Insurance Australia policies'
        },
        hasGapOnly: true
      },
      footerSections: null
    }),
    aside: {
      campaigns: [/*#__PURE__*/_react["default"].createElement("div", {
        key: "PIAContactCampaign",
        className: "PIAContact"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        className: "fullSizeImageLink needHelpLink",
        href: "tel://1800043552",
        style: {
          backgroundImage: 'url("https://petcdnstore.blob.core.windows.net/qt-assets/Prod/PIA/phone_tile.svg")'
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "sr-only"
      }, "Need help? Call us on 1800 043 552 between 8:00am and 6:30pm (AEST) Monday to Friday (except public holidays)"))), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "PIACampaign1",
        customCssClass: "PIACampaign1",
        campaignImageDescription: "myPetPass logo",
        campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/Common/MyPetPass_QT_tile_464x400.png",
        __type: "CampaignHolder"
      }), /*#__PURE__*/_react["default"].createElement(_components.CampaignHolder, {
        key: "PIACampaign2",
        customCssClass: "PIACampaign2",
        campaignImageDescription: "GapOnly ready Pet Insurance",
        campaignImageUrl: "https://petcdnstore.blob.core.windows.net/qt-assets/Prod/Common/GapOnly_tile_232x200.png",
        __type: "CampaignHolder"
      }), /*#__PURE__*/_react["default"].createElement("a", {
        key: "PIAPDS",
        className: "pdsLink",
        target: "_blank",
        rel: "noreferrer",
        href: "https://www.petinsuranceaustralia.com.au/useful-documents/"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Click here to view the Product Disclosure Statement"), /*#__PURE__*/_react["default"].createElement(_components.Icon, {
        icon: "file-text"
      }))]
    }
  })
});
PIAThemeContext.contactStatement = function (contactStatementLogoUrl) {
  return (0, _contactStatement.coBrandContactStatement)(contactStatementLogoUrl, PIAThemeContext.brand.fullName, PIAThemeContext.brand.supportPhoneNumber, _contactStatement.petSurePhoneNumber, 'Continue to cover options', PIAThemeContext.brand.shortName);
};
PIAThemeContext.privacyCollectionNotice = function (contactStatementLogoUrl) {
  return (0, _contactStatement.coBrandPrivacyCollectionNotice)(contactStatementLogoUrl, PIAThemeContext.brand.fullName, PIAThemeContext.brand.supportPhoneNumber, _contactStatement.petSurePhoneNumber, 'Continue to summary', PIAThemeContext.brand.supportEmailAddress, PIAThemeContext.brand.shortName);
};
var _default = exports["default"] = {
  PIAThemeContext: PIAThemeContext
};